var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('error',{attrs:{"name":'403',"desc":'抱歉，你无权访问该页面'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }